/* globals sift */
angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetSiteStatus', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetSiteStatusController
  });

zcsDashboardWidgetSiteStatusController.$inject = ['$translate', '$q', 'ZcsCampaignStats', 'ZcsInvoice', 'ZcsOemService', 'Campaign', 'currencies'];
function zcsDashboardWidgetSiteStatusController($translate, $q, ZcsCampaignStats, ZcsInvoice, ZcsOemService, Campaign, currencies) {
  const vm = this;
  const isOem = ZcsOemService.isOemService();
  const CHART_DATE_FORMAT = 'YYYY-MM-DD';
  const DEFAULT_MAX_INVOICE_PRICE = 10000;
  const COLORS = {
    primary: angular.element('.zc-primary').css('color') || '#1DD5A3',
    secondary: angular.element('.zc-secondary').css('color') || '#775FD3',
    tertiary: angular.element('.zc-tertiary').css('color') || '#A6B1BB',
  };

  function formatFraction(number) {
    return number / (10 ** vm.currency.fractionSize);
  }

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
    vm.isLoading = true;
    vm.invoiceLimitReached = false;
    vm.showNoDataOverlay = false;
    vm.hasActiveCampaigns = false;
    vm.currentMonth = moment().format('YYYY/MM');
    vm.currency = currencies[vm.project.currency];
    vm.legends = {
      totalFeeTaxExcluded: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.seika_houshuu_suii'),
      maxInvoicePrice: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.seikyuu_jougen'),
      totalConversionPrice: vm.project.invoice_calculation_type === 'deemed'
        ? $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.haishin_yuuzaano_uriage')
        : $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.kuupon_riyou_uriage'),
      minimumCharge: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.minimamuchaaji'),
    };

    const invoicesPromise = ZcsInvoice.find(vm.project.apikey, moment().format('YYYY-MM'));
    const campaignsPromise = Campaign.all({projectId: vm.project.id});
    const campaignStatsPromise = ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: 'daily'
    }, {
      start_at: {
        $gte: moment().startOf('month').toDate(),
        $lt: moment().endOf('month').toDate()
      }
    });

    $q.all([
      invoicesPromise,
      campaignsPromise,
      campaignStatsPromise,
    ]).then(([
      invoice,
      campaigns,
      campaignStats,
    ]) => {
      vm.campaignStats = campaignStats;
      vm.stats = {};
      vm.stats.totalConversionPrice = _.sumBy(
        campaignStats,
        'effective_conversion_price'
      );
      vm.stats.totalConversionCount = _.sumBy(
        campaignStats,
        'effective_conversion_count'
      );
      vm.stats.totalFeeTaxExcluded = _.sumBy(
        campaignStats,
        'zc_fee_tax_excluded'
      );
      vm.stats.invoicePriceTaxExcluded = _.get(invoice, 'invoice_price_tax_excluded', 0);
      vm.stats.maxInvoicePrice = _.get(invoice, 'max_invoice', 0);
      if(invoice.adjustments.length > 0) {
        vm.stats.minimumCharge = _.chain(invoice.adjustments)
          .filter({adjustment_name: 'minimum_charge'})
          .sum('price')
          .value();
      }

      if(!vm.stats.maxInvoicePrice) {
        vm.stats.maxInvoicePrice = DEFAULT_MAX_INVOICE_PRICE;
      }

      vm.stats.isInvoiceLimitReached = (vm.stats.totalFeeTaxExcluded >= vm.stats.maxInvoicePrice) && !vm.project.fixed_invoice_amount;

      const activeCampaigns = sift(Campaign.activeFilters(), campaigns);
      const activeCampaignsThisMonth = sift(Campaign.activeFiltersThisMonth(), campaigns);
      vm.hasActiveCampaigns = activeCampaigns.length > 0;
      vm.hasActiveCampaignsThisMonth = activeCampaignsThisMonth.length > 0;

      if(campaignStats && campaignStats.length <= 0) {
        applyNoDataStatus();
      }

      let feeTaxExcludedSum = 0;
      let chartData = _.chain(vm.campaignStats)
        .sortBy(d => d.start_at)
        .groupBy(d => d.start_at)
        .map(d => {
          feeTaxExcludedSum += _.sumBy(d, 'zc_fee_tax_excluded');
          return {
            x: moment(d[0].start_at).format(CHART_DATE_FORMAT),
            y: formatFraction(feeTaxExcludedSum),
          };
        })
        .value();
      chartData = fillDatesBeforeCampaignsStarted(chartData);

      vm.domainValues = getDomainValues();
      vm.chartInvoiceData = [
        {
          key: vm.legends.totalFeeTaxExcluded,
          values: chartData,
          color: COLORS.primary,
        },
      ];

      const borderLineXAxisDates = [
        // subtract 1 day to make the line start from the very left of the chart
        moment().startOf('month').subtract(1, 'day').valueOf(),
        moment().endOf('month').valueOf(),
      ];

      if(vm.stats.maxInvoicePrice > 0 && !vm.project.fixed_invoice_amount) {
        const invoicePriceData = _.map(borderLineXAxisDates, d => {
          return {
            x: d,
            y: formatFraction(vm.stats.maxInvoicePrice),
          };
        });

        vm.chartInvoiceData.push({
          key: vm.legends.maxInvoicePrice,
          values: invoicePriceData,
          color: COLORS.secondary
        });
      }

      if(!isOem && vm.stats.minimumCharge > 0) {
        const minimumChargeData = _.map(borderLineXAxisDates, d => {
          return {
            x: d,
            y: formatFraction(vm.stats.minimumCharge),
          };
        });

        vm.chartInvoiceData.push({
          key: vm.legends.minimumCharge,
          values: minimumChargeData,
          color: COLORS.tertiary,
        });
      }

      vm.isLoading = false;
    });
  };

  function fillDatesBeforeCampaignsStarted(chartData) {
    const dateCampaignsStarted = moment(_.minBy(chartData, d => moment(d.x)).x).valueOf();
    let xDomainDate = moment().startOf('month').valueOf();

    while(xDomainDate < dateCampaignsStarted) {
      chartData.push({
        x: moment(xDomainDate).format(CHART_DATE_FORMAT),
        y: 0
      });
      xDomainDate = moment(xDomainDate).add(1, 'day').valueOf();
    }

    return _.sortBy(chartData, d => d.x);
  }

  function applyNoDataStatus() {
    vm.stats = generateDummyStats();
    vm.campaignStats = generateDummyCampaignStats();
  }

  function generateDummyStats() {
    return {
      totalFeeTaxExcluded: 0,
      maxInvoicePrice: DEFAULT_MAX_INVOICE_PRICE,
      totalConversionPrice: 0,
    };
  }

  function generateDummyCampaignStats() {
    const today = moment().endOf('today').valueOf();
    let xDomainDate = moment().startOf('month').valueOf();
    let dummyCampaignStats = [];

    while(xDomainDate < today) {
      dummyCampaignStats.push({
        start_at: xDomainDate,
        end_at: moment(xDomainDate).endOf('day').valueOf(),
        zc_fee_tax_excluded: 0,
      });
      xDomainDate = moment(xDomainDate).add(1, 'day').valueOf();
    }

    return dummyCampaignStats;
  }

  function getXDomainValues() {
    const minDate = moment().startOf('month');
    const maxDate = moment().endOf('month');

    return [
      moment(minDate).subtract(1, 'day').valueOf(),
      maxDate.valueOf(),
    ];
  }

  function getYDomainValues() {
    const yMin = 0;
    const yMaxPadding = 1.1;
    let yMax = formatFraction(vm.stats.totalFeeTaxExcluded);

    if(!vm.stats.isInvoiceLimitReached) {
      yMax = formatFraction(vm.stats.maxInvoicePrice);
    }

    yMax *= yMaxPadding;

    return [yMin, yMax];
  }

  function getDomainValues() {
    return {
      x: getXDomainValues(),
      y: getYDomainValues(),
    };
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.component.js